<div class="business-setting-container">

  <!-- ========================================================= -->
  <!-- HEADER -->
  <!-- ========================================================= -->

  <div class="business-setting-header">

    <div class="title-section">

      <div class="title-icon">
        <i class="fa-solid fa-sliders"></i>
      </div>

      <div class="title-content">

        <h1 class="business-setting-title">
          Business Settings
        </h1>

        <!-- ✅ snake_case -->
        <span class="settings-count">

          {{ paged.total_count }}

          {{
            paged.total_count === 1
              ? 'setting'
              : 'settings'
          }}

        </span>

      </div>

    </div>


    <div class="header-actions">

      <div class="search-wrapper">

        <i class="fa-solid fa-magnifying-glass search-icon"></i>

        <input
          type="text"
          class="search-input"
          [(ngModel)]="searchTerm"
          (input)="onSearch()"
          placeholder="Search settings..."
          [disabled]="loading"
        />

        <button
          *ngIf="searchTerm"
          type="button"
          class="clear-search"
          (click)="clearSearch()"
          title="Clear search"
          [disabled]="loading"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>

      </div>


      <button
        type="button"
        class="add-button"
        (click)="openCreateModal()"
        [disabled]="loading"
      >

        <i class="fa-solid fa-plus button-icon"></i>

        <span>
          Add Setting
        </span>

      </button>

    </div>

  </div>


  <!-- ========================================================= -->
  <!-- TABLE -->
  <!-- ========================================================= -->

  <div class="settings-table">

    <div class="table-header">

      <div class="header-cell id-cell">
        <i class="fa-solid fa-hashtag"></i>
        <span>ID</span>
      </div>

      <div class="header-cell image-header">
        <i class="fa-regular fa-image"></i>
        <span>Image</span>
      </div>

      <div class="header-cell type-header">
        <i class="fa-solid fa-tag"></i>
        <span>Type</span>
      </div>

      <div class="header-cell value-header">
        <i class="fa-solid fa-link"></i>
        <span>Image URL</span>
      </div>

      <div class="header-cell status-header">
        <i class="fa-solid fa-toggle-on"></i>
        <span>Status</span>
      </div>

      <div class="header-cell action-header">
        <span>Actions</span>
      </div>

    </div>


    <!-- ========================================================= -->
    <!-- LOADING -->
    <!-- ========================================================= -->

    <div
      *ngIf="loading"
      class="table-loading"
    >

      <div class="spinner"></div>

      <span>
        Loading business settings...
      </span>

    </div>


    <!-- ========================================================= -->
    <!-- DATA -->
    <!-- ========================================================= -->

    <ng-container *ngIf="!loading">

      <div
        *ngFor="
          let setting of filteredSettings;
          trackBy: trackById
        "
        class="setting-row"
      >

        <!-- ID -->

        <div class="cell id-cell">
          <span class="setting-id">
            #{{ setting.id }}
          </span>
        </div>


        <!-- IMAGE -->

        <div class="cell image-cell">

          <ng-container
            *ngIf="
              isImageUrl(setting.value);
              else noImage
            "
          >

            <img
              class="setting-thumb"
              [src]="setting.value"
              [alt]="getTypeLabel(setting.type)"
              appImageFallback
            />

          </ng-container>


          <ng-template #noImage>

            <span class="no-image-placeholder">
              <i class="fa-regular fa-image"></i>
            </span>

          </ng-template>

        </div>


        <!-- TYPE -->

        <div class="cell">

          <div class="type-wrapper">

            <span class="type-badge">

              <i class="fa-solid fa-gear"></i>

              <span>
                {{ getTypeLabel(setting.type) }}
              </span>

            </span>

          </div>

        </div>


        <!-- VALUE -->

        <div class="cell value-cell">

          <span
            class="value-text"
            [title]="setting.value || ''"
          >
            {{ setting.value || '—' }}
          </span>

        </div>


        <!-- STATUS -->

        <div class="cell status-cell">

          <span
            class="status-badge"
            [class.active]="isActive(setting.status)"
            [class.inactive]="!isActive(setting.status)"
          >

            <i
              class="fa-solid"
              [class.fa-circle-check]="isActive(setting.status)"
              [class.fa-circle-xmark]="!isActive(setting.status)"
            ></i>

            {{ getStatusLabel(setting.status) }}

          </span>

        </div>


        <!-- ACTIONS -->

        <div class="cell">

          <div class="action-buttons">

            <button
              type="button"
              class="btn-edit"
              (click)="openEditModal(setting)"
              [disabled]="saving || deleting"
              title="Edit"
              aria-label="Edit setting"
            >
              <i class="fa-solid fa-pen"></i>
            </button>


            <button
              type="button"
              class="btn-delete"
              (click)="openDeleteModal(setting)"
              [disabled]="saving || deleting"
              title="Delete"
              aria-label="Delete setting"
            >
              <i class="fa-solid fa-trash"></i>
            </button>

          </div>

        </div>

      </div>


      <!-- ======================================================= -->
      <!-- EMPTY -->
      <!-- ======================================================= -->

      <div
        *ngIf="filteredSettings.length === 0"
        class="no-settings"
      >

        <div class="empty-icon">
          <i class="fa-solid fa-sliders"></i>
        </div>

        <div class="empty-title">
          No business settings found
        </div>

        <div class="empty-description">

          {{
            searchTerm
              ? 'Try changing your search criteria.'
              : 'There are no business settings available yet.'
          }}

        </div>

        <button
          *ngIf="searchTerm"
          type="button"
          class="empty-clear-button"
          (click)="clearSearch()"
        >

          <i class="fa-solid fa-xmark"></i>
          Clear Search

        </button>

      </div>

    </ng-container>

  </div>


  <!-- ========================================================= -->
  <!-- PAGINATION ✅ snake_case -->
  <!-- ========================================================= -->

  <div
    *ngIf="
      !loading &&
      paged.total_count > 0
    "
    class="pagination-controls"
  >

    <div class="pagination-info">

      <span>Showing</span>

      <strong>{{ showingFrom }}</strong>

      <span>-</span>

      <strong>{{ showingTo }}</strong>

      <span>of</span>

      <strong>{{ paged.total_count }}</strong>

    </div>


    <div class="pagination-buttons">

      <button
        type="button"
        class="pagination-btn"
        [disabled]="
          loading ||
          !paged.has_previous_page
        "
        (click)="previousPage()"
      >

        <i class="fa-solid fa-chevron-left"></i>

        <span>Previous</span>

      </button>


      <div class="page-numbers">

        <button
          *ngFor="let page of pageNumbers"
          type="button"
          class="page-btn"
          [class.active]="page === pageNumber"
          [disabled]="
            loading ||
            page === pageNumber
          "
          (click)="goToPage(page)"
        >

          {{ page }}

        </button>

      </div>


      <button
        type="button"
        class="pagination-btn"
        [disabled]="
          loading ||
          !paged.has_next_page
        "
        (click)="nextPage()"
      >

        <span>Next</span>

        <i class="fa-solid fa-chevron-right"></i>

      </button>

    </div>


    <div class="items-per-page">

      <span>Per page</span>

      <select
        [(ngModel)]="pageSize"
        (change)="onPageSizeChange()"
        [disabled]="loading"
      >

        <option [ngValue]="10">10</option>
        <option [ngValue]="20">20</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>

      </select>

    </div>

  </div>

</div>


<!-- =========================================================== -->
<!-- CREATE MODAL -->
<!-- =========================================================== -->

<div
  *ngIf="showCreateModal"
  class="modal-overlay"
  (click)="closeCreateModal()"
>

  <div
    class="modal-container"
    (click)="$event.stopPropagation()"
  >

    <div class="modal-header">

      <div class="modal-title-wrapper">

        <div class="modal-icon create-icon">
          <i class="fa-solid fa-plus"></i>
        </div>

        <div>
          <h2>Create Business Setting</h2>
          <p>Add a new logo setting</p>
        </div>

      </div>


      <button
        type="button"
        class="modal-close"
        [disabled]="saving"
        (click)="closeCreateModal()"
        aria-label="Close"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>

    </div>


    <div class="modal-body">

      <!-- TYPE -->

      <div class="form-group">

        <label>
          Setting Type
          <span>*</span>
        </label>

        <div class="input-wrapper">

          <i class="fa-solid fa-tag"></i>

          <select
            [(ngModel)]="form.type"
            [disabled]="saving"
          >

            <option value="" disabled>
              Select setting type
            </option>

            <option value="header_logo">
              Header Logo
            </option>

            <option value="footer_logo">
              Footer Logo
            </option>

            <option value="system_logo_white">
              System Logo White
            </option>

            <option value="system_logo_black">
              System Logo Black
            </option>

          </select>

        </div>

      </div>


      <!-- STATUS -->

      <div class="form-group">

        <label>
          Status
          <span>*</span>
        </label>

        <div class="input-wrapper">

          <i class="fa-solid fa-toggle-on"></i>

          <select
            [(ngModel)]="form.status"
            [disabled]="saving"
          >

            <option [ngValue]="1">Active</option>
            <option [ngValue]="0">Inactive</option>

          </select>

        </div>

      </div>


      <!-- IMAGE -->

      <div class="form-group">

        <label>
          Image
          <span>*</span>
        </label>


        <div class="input-wrapper">

          <i class="fa-solid fa-link"></i>

          <input
            type="text"
            [(ngModel)]="form.value"
            placeholder="Choose image from gallery"
            readonly
            [disabled]="saving"
          />

        </div>


        <button
          type="button"
          class="btn-add"
          (click)="openGalleryModal()"
          [disabled]="saving"
        >
          🖼️ اختيار من الجاليري
        </button>


        <!-- SELECTED IMAGE -->

        <div
          class="selected-images"
          *ngIf="selectedPhoto"
        >

          <div class="selected-image-card">

            <img
              [src]="selectedPhoto.url | ImageUrlPipe"
              [alt]="selectedPhoto.name"
              appImageFallback
            />


            <div class="selected-image-info">

              <span>{{ selectedPhoto.name }}</span>

              <small>ID: {{ selectedPhoto.id }}</small>

            </div>


            <button
              type="button"
              class="btn-remove"
              (click)="removeSelectedPhoto()"
              [disabled]="saving"
            >
              حذف
            </button>

          </div>

        </div>


        <!-- PREVIEW -->

        <div
          *ngIf="
            form.value &&
            isImageUrl(form.value)
          "
          class="image-preview"
        >

          <span class="preview-label">Preview</span>

          <div class="preview-image-wrapper">

            <img
              [src]="form.value"
              alt="Image preview"
              appImageFallback
            />

          </div>

        </div>


        <!-- GALLERY -->

        <app-gallery-picker
          *ngIf="isGalleryModalOpen"
          [selectedImages]="selectedPhoto ? [selectedPhoto] : []"
          (selectedImagesChange)="onGalleryImagesChange($event)"
          (close)="closeGalleryModal()"
        >
        </app-gallery-picker>

      </div>

    </div>


    <div class="modal-footer">

      <button
        type="button"
        class="cancel-button"
        [disabled]="saving"
        (click)="closeCreateModal()"
      >
        Cancel
      </button>


      <button
        type="button"
        class="save-button"
        [disabled]="
          saving ||
          !isFormValid()
        "
        (click)="create()"
      >

        <span
          *ngIf="saving"
          class="button-spinner"
        ></span>

        <i
          *ngIf="!saving"
          class="fa-solid fa-check"
        ></i>

        {{ saving ? 'Creating...' : 'Create Setting' }}

      </button>

    </div>

  </div>

</div>


<!-- =========================================================== -->
<!-- UPDATE MODAL -->
<!-- =========================================================== -->

<div
  *ngIf="showEditModal"
  class="modal-overlay"
  (click)="closeEditModal()"
>

  <div
    class="modal-container"
    (click)="$event.stopPropagation()"
  >

    <div class="modal-header">

      <div class="modal-title-wrapper">

        <div class="modal-icon edit-icon">
          <i class="fa-solid fa-pen"></i>
        </div>

        <div>
          <h2>Update Business Setting</h2>
          <p>Edit setting #{{ selectedSetting?.id }}</p>
        </div>

      </div>


      <button
        type="button"
        class="modal-close"
        [disabled]="saving"
        (click)="closeEditModal()"
        aria-label="Close"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>

    </div>


    <div class="modal-body">

      <!-- TYPE -->

      <div class="form-group">

        <label>
          Setting Type
          <span>*</span>
        </label>

        <div class="input-wrapper">

          <i class="fa-solid fa-tag"></i>

          <select
            [(ngModel)]="form.type"
            [disabled]="saving"
          >

            <option value="" disabled>
              Select setting type
            </option>

            <option value="header_logo">Header Logo</option>
            <option value="footer_logo">Footer Logo</option>
            <option value="system_logo_white">System Logo White</option>
            <option value="system_logo_black">System Logo Black</option>

          </select>

        </div>

      </div>


      <!-- STATUS -->

      <div class="form-group">

        <label>
          Status
          <span>*</span>
        </label>

        <div class="input-wrapper">

          <i class="fa-solid fa-toggle-on"></i>

          <select
            [(ngModel)]="form.status"
            [disabled]="saving"
          >

            <option [ngValue]="1">Active</option>
            <option [ngValue]="0">Inactive</option>

          </select>

        </div>

      </div>


      <!-- IMAGE -->

      <div class="form-group">

        <label>
          Image
          <span>*</span>
        </label>


        <div class="input-wrapper">

          <i class="fa-solid fa-link"></i>

          <input
            type="text"
            [(ngModel)]="form.value"
            placeholder="Choose image from gallery"
            readonly
            [disabled]="saving"
          />

        </div>


        <button
          type="button"
          class="btn-add"
          (click)="openGalleryModal()"
          [disabled]="saving"
        >
          🖼️ اختيار من الجاليري
        </button>


        <!-- CURRENT / SELECTED IMAGE -->

        <div
          class="selected-images"
          *ngIf="selectedPhoto || form.value"
        >

          <div class="selected-image-card">

            <img
              [src]="
                selectedPhoto
                  ? (selectedPhoto.url | ImageUrlPipe)
                  : form.value
              "
              [alt]="
                selectedPhoto?.name ||
                getTypeLabel(form.type)
              "
              appImageFallback
            />


            <div class="selected-image-info">

              <span>
                {{
                  selectedPhoto?.name ||
                  getTypeLabel(form.type)
                }}
              </span>


              <small *ngIf="selectedPhoto">
                ID: {{ selectedPhoto.id }}
              </small>

            </div>


            <button
              type="button"
              class="btn-remove"
              (click)="removeSelectedPhoto()"
              [disabled]="saving"
            >
              حذف
            </button>

          </div>

        </div>


        <!-- PREVIEW -->

        <div
          *ngIf="
            form.value &&
            isImageUrl(form.value)
          "
          class="image-preview"
        >

          <span class="preview-label">Preview</span>

          <div class="preview-image-wrapper">

            <img
              [src]="form.value"
              alt="Image preview"
              appImageFallback
            />

          </div>

        </div>


        <!-- GALLERY -->

        <app-gallery-picker
          *ngIf="isGalleryModalOpen"
          [selectedImages]="selectedPhoto ? [selectedPhoto] : []"
          (selectedImagesChange)="onGalleryImagesChange($event)"
          (close)="closeGalleryModal()"
        >
        </app-gallery-picker>

      </div>

    </div>


    <div class="modal-footer">

      <button
        type="button"
        class="cancel-button"
        [disabled]="saving"
        (click)="closeEditModal()"
      >
        Cancel
      </button>


      <button
        type="button"
        class="save-button update-button"
        [disabled]="
          saving ||
          !isFormValid()
        "
        (click)="update()"
      >

        <span
          *ngIf="saving"
          class="button-spinner"
        ></span>

        <i
          *ngIf="!saving"
          class="fa-solid fa-check"
        ></i>

        {{ saving ? 'Updating...' : 'Update Setting' }}

      </button>

    </div>

  </div>

</div>


<!-- =========================================================== -->
<!-- DELETE MODAL -->
<!-- =========================================================== -->

<div
  *ngIf="showDeleteModal"
  class="modal-overlay"
  (click)="closeDeleteModal()"
>

  <div
    class="delete-modal"
    (click)="$event.stopPropagation()"
  >

    <div class="delete-icon">
      <i class="fa-solid fa-trash"></i>
    </div>


    <h2>Delete Business Setting?</h2>


    <p>

      Are you sure you want to delete

      <strong>
        "{{ selectedSetting?.type }}"
      </strong>

      ?

      <br />

      This action cannot be undone.

    </p>


    <div class="delete-actions">

      <button
        type="button"
        class="cancel-button"
        [disabled]="deleting"
        (click)="closeDeleteModal()"
      >
        Cancel
      </button>


      <button
        type="button"
        class="delete-confirm-button"
        [disabled]="deleting"
        (click)="delete()"
      >

        <span
          *ngIf="deleting"
          class="button-spinner"
        ></span>

        <i
          *ngIf="!deleting"
          class="fa-solid fa-trash"
        ></i>

        {{ deleting ? 'Deleting...' : 'Delete' }}

      </button>

    </div>

  </div>

</div>